export default __webpack_public_path__ + "static/media/019-xylophone.34483a94.svg";